import React, { useState } from "react";
import { getQueueWrapupCodes } from "../utilities/genesysCloudUtils";
import "../App.css";
import { CatalogTableSurface } from "./CatalogTableSurface";

export function Queues({
  queues,
  pageNumber,
  queueCache,
  setQueueCache,
  selectedExportRows = {},
  exportStatus,
  onClearExportSelection,
  onExportCsv,
  onToggleExportRow,
  onToggleVisibleExportRows,
}) {
  const [loadingQueueIds, setLoadingQueueIds] = useState({});
  const allVisibleSelected = queues.length > 0 && queues.every((queue) => selectedExportRows[queue.id]);

  const loadWrapupCodes = async (queue) => {
    if (Object.prototype.hasOwnProperty.call(queueCache, queue.id)) {
      queue.wrapUpCodes = queueCache[queue.id];
      setQueueCache((current) => ({ ...current }));
      return;
    }

    setLoadingQueueIds((current) => ({ ...current, [queue.id]: true }));
    try {
      const data = await getQueueWrapupCodes(queue.id, { pageSize: 500, pageNumber: 1 });
      queue.wrapUpCodes = data.entities || [];
      setQueueCache((current) => ({ ...current, [queue.id]: queue.wrapUpCodes }));
    } finally {
      setLoadingQueueIds((current) => {
        const next = { ...current };
        delete next[queue.id];
        return next;
      });
    }
  };

  return (
    <CatalogTableSurface
      allVisibleSelected={allVisibleSelected}
      exportStatus={exportStatus}
      filteredExportAvailable={true}
      onClearSelection={onClearExportSelection}
      onExportCurrent={() => onExportCsv({ mode: "current", records: queues })}
      onExportFiltered={() => onExportCsv({ mode: "all" })}
      onExportSelected={() => onExportCsv({ mode: "selected" })}
      onSelectVisible={(checked) => onToggleVisibleExportRows(queues, checked)}
      rowCount={queues.length}
      selectedCount={Object.keys(selectedExportRows).length}
      title="Queues"
    >
      <table className="table">
        <thead>
          <tr>
            <th aria-label="Select rows" className="select-column"></th>
            <th>Count</th>
            <th>Queue Name</th>
            <th>Description</th>
            <th></th>
            <th>Queue Id</th>
          </tr>
        </thead>
        <tbody>
          {queues.map((queue, index) => {
            return (
              <tr key={queue.id}>
                <td className="select-column">
                  <input
                    aria-label={`Select ${queue.name} for export`}
                    checked={Boolean(selectedExportRows[queue.id])}
                    onChange={(event) => onToggleExportRow(queue, event.target.checked)}
                    type="checkbox"
                  />
                </td>
                <th className="index">
                  {pageNumber === 1
                    ? index + 1
                    : (pageNumber - 1) * 100 + index + 1}
                </th>
                <td>{queue.name}</td>
                <td>{queue.description ? queue.description : ""}</td>
                <td>
                  <div className="collapse collapse-arrow">
                    <input
                      type="checkbox"
                    />
                    <div className="collapse-title">Settings</div>
                    <div className="collapse-content">
                      <table className="table-xs">
                        <thead>
                          <tr>
                            <th>Division:</th>
                            <td>{queue.division.name}</td>
                          </tr>
                          <tr>
                            <th>ACW/Timeout:</th>
                            <td>
                              {queue.acwSettings.timeoutMs
                                ? queue.acwSettings.wrapupPrompt +
                                " - " +
                                queue.acwSettings.timeoutMs / 1000 +
                                "s"
                                : queue.acwSettings.wrapupPrompt}
                            </td>
                          </tr>
                          {/* <tr>
                            <th>Auto Answer?:</th>
                            <td>{queue.autoAnswerOnly ? "Yes" : "No"}</td>
                          </tr> */}
                          <tr>
                            <th>Channel:</th>
                            <td>
                              <div className="collapse collapse-arrow">
                                <input type="checkbox" />
                                <div className="collapse-title">Voice</div>
                                <div className="collapse-content">
                                  <table className="table-xs">
                                    <thead>
                                      <tr>
                                        <th>Auto Answer:</th>
                                        <td>
                                          {queue.mediaSettings.call
                                            .enableAutoAnswer
                                            ? "On"
                                            : "Off"}
                                        </td>
                                      </tr>
                                      <tr>
                                        <th>Alerting Timeout:</th>
                                        <td>
                                          {
                                            queue.mediaSettings.call
                                              .alertingTimeoutSeconds
                                          }
                                          s
                                        </td>
                                      </tr>
                                      <tr>
                                        <th>Service Level:</th>
                                        <td>
                                          {queue.mediaSettings.call.serviceLevel
                                            .percentage * 100}
                                          % /{" "}
                                          {queue.mediaSettings.call.serviceLevel
                                            .durationMs / 1000}
                                          s
                                        </td>
                                      </tr>
                                      <tr>
                                        <th>Calling Party:</th>
                                        <td>
                                          {queue.callingPartyName
                                            ? `${queue.callingPartyName}`
                                            : ""}{" "}
                                          {queue.callingPartyNumber
                                            ? `${queue.callingPartyNumber}`
                                            : ""}
                                        </td>
                                      </tr>
                                      <tr>
                                        <th>Transcription:</th>
                                        <td>
                                          {queue.enableTranscription
                                            ? "Enabled"
                                            : "Disabled"}
                                        </td>
                                      </tr>
                                      {/* <tr>
                                        <th>Default Script:</th>
                                        <td>
                                          {queue.CALL
                                            ? queue.CALL.id
                                            : ""}
                                        </td>
                                      </tr> */}
                                    </thead>
                                  </table>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <th></th>
                            <td>
                              <div className="collapse collapse-arrow">
                                <input type="checkbox" />
                                <div className="collapse-title">Callback</div>
                                <div className="collapse-content">
                                  <table className="table-xs">
                                    <thead>
                                      <tr>
                                        <th>Auto Answer:</th>
                                        <td>
                                          {queue.mediaSettings.callback
                                            .enableAutoAnswer
                                            ? "On"
                                            : "Off"}
                                        </td>
                                      </tr>
                                      <tr>
                                        <th>Alerting Timeout:</th>
                                        <td>
                                          {
                                            queue.mediaSettings.callback
                                              .alertingTimeoutSeconds
                                          }
                                          s
                                        </td>
                                      </tr>
                                      <tr>
                                        <th>Mode:</th>
                                        <td>
                                          {queue.mediaSettings.callback.mode}
                                        </td>
                                      </tr>
                                      <tr>
                                        <th>Auto Dial and End:</th>
                                        <td>
                                          {queue.mediaSettings.callback
                                            .enableAutoDialAndEnd
                                            ? "On"
                                            : "Off"}
                                        </td>
                                      </tr>
                                      {queue.mediaSettings.callback
                                        .enableAutoDialAndEnd && (
                                          <>

                                            <tr>
                                              <th>Auto Dial Delay:</th>
                                              <td>
                                                {queue.mediaSettings.callback
                                                  .autoDialDelaySeconds}s
                                              </td>
                                            </tr>
                                            <tr>
                                              <th>Auto End Delay:</th>
                                              <td>
                                                {queue.mediaSettings.callback
                                                  .autoEndDelaySeconds}s
                                              </td>
                                            </tr>
                                          </>
                                        )}
                                      <tr>
                                        <th>Service Level:</th>
                                        <td>
                                          {queue.mediaSettings.callback
                                            .serviceLevel.percentage * 100}
                                          % /{" "}
                                          {queue.mediaSettings.callback
                                            .serviceLevel.durationMs / 1000}
                                          s
                                        </td>
                                      </tr>
                                      {/* <tr>
                                        <th>Voice SLA:</th>
                                        <td></td>
                                      </tr> */}
                                    </thead>
                                  </table>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <th></th>
                            <td>
                              <div className="collapse collapse-arrow">
                                <input type="checkbox" />
                                <div className="collapse-title">Message</div>
                                <div className="collapse-content">
                                  <table className="table-xs">
                                    <thead>
                                      <tr>
                                        <th>Auto Answer:</th>
                                        <td>
                                          {queue.mediaSettings.message
                                            .enableAutoAnswer
                                            ? "On"
                                            : "Off"}
                                        </td>
                                      </tr>
                                      <tr>
                                        <th>Alerting Timeout:</th>
                                        <td>
                                          {
                                            queue.mediaSettings.message
                                              .alertingTimeoutSeconds
                                          }
                                          s
                                        </td>
                                      </tr>
                                      <tr>
                                        <th>Service Level:</th>
                                        <td>
                                          {queue.mediaSettings.message
                                            .serviceLevel.percentage * 100}
                                          % /{" "}
                                          {queue.mediaSettings.message
                                            .serviceLevel.durationMs / 1000}
                                          s
                                        </td>
                                      </tr>
                                      {/* <tr>
                                        <th>Voice SLA:</th>
                                        <td></td>
                                      </tr> */}
                                    </thead>
                                  </table>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <th></th>
                            <td>
                              <div className="collapse collapse-arrow">
                                <input type="checkbox" />
                                <div className="collapse-title">Email</div>
                                <div className="collapse-content">
                                  <table className="table-xs">
                                    <thead>
                                      <tr>
                                        <th>Auto Answer:</th>
                                        <td>
                                          {queue.mediaSettings.email
                                            .enableAutoAnswer
                                            ? "On"
                                            : "Off"}
                                        </td>
                                      </tr>
                                      <tr>
                                        <th>Alerting Timeout:</th>
                                        <td>
                                          {
                                            queue.mediaSettings.email
                                              .alertingTimeoutSeconds
                                          }
                                          s
                                        </td>
                                      </tr>
                                      <tr>
                                        <th>Service Level:</th>
                                        <td>
                                          {queue.mediaSettings.email
                                            .serviceLevel.percentage * 100}
                                          % /{" "}
                                          {queue.mediaSettings.email
                                            .serviceLevel.durationMs / 1000}
                                          s
                                        </td>
                                      </tr>
                                      <tr>
                                        <th>Email Address:</th>
                                        <td>
                                          {queue.outboundEmailAddress
                                            ? queue.outboundEmailAddress.route
                                              .pattern +
                                            "@" +
                                            queue.outboundEmailAddress.domain
                                              .id
                                            : ""}
                                        </td>
                                      </tr>
                                      {/* <tr>
                                        <th>Voice SLA:</th>
                                        <td></td>
                                      </tr> */}
                                    </thead>
                                  </table>
                                </div>
                              </div>
                            </td>
                          </tr>
                          {/* <tr>
                            <div className="collapse collapse-arrow">
                              <input type="checkbox" />
                              <div className="collapse-title">Callback</div>
                              <div className="collapse-content">
                                <table className="table-xs">
                                  <thead>
                                    <tr>
                                      <th>Alerting Timeout:</th>
                                      <td>
                                        {
                                          queue.mediaSettings.callback
                                            .alertingTimeoutSeconds
                                        }
                                        s
                                      </td>
                                    </tr>
                                    <tr>
                                      <th>Mode:</th>
                                      <td>
                                        {queue.mediaSettings.callback.mode}
                                      </td>
                                    </tr>
                                    <tr>
                                      <th>Service Level:</th>
                                      <td>
                                        {queue.mediaSettings.callback
                                          .serviceLevel.percentage * 100}
                                        % /{" "}
                                        {queue.mediaSettings.callback
                                          .serviceLevel.durationMs / 1000}
                                        s
                                      </td>
                                    </tr>
                                    <tr>
                                      <th>Voice SLA:</th>
                                      <td></td>
                                    </tr>
                                  </thead>
                                  <tbody></tbody>
                                </table>
                              </div>
                            </div>
                          </tr> */}
                        </thead>
                        <tbody></tbody>
                      </table>
                    </div>
                  </div>
                  <div className="collapse collapse-arrow">
                    <input
                      type="checkbox"
                      onChange={(event) => {
                        if (event.target.checked && !loadingQueueIds[queue.id] && !queue.wrapUpCodes) {
                          loadWrapupCodes(queue);
                        }
                      }}
                    />
                    <div className="collapse-title">
                      {loadingQueueIds[queue.id] ? (
                        <span className="queue-wrapupcodes-loading" role="status" aria-label="Loading wrapup codes" />
                      ) : (
                        `Wrapup Codes${queue.wrapUpCodes ? `: ${queue.wrapUpCodes.length}` : ""}`
                      )}
                    </div>
                    <div className="collapse-content">
                      {queue.wrapUpCodes && (
                        <div className="queue-wrapupcodes-list">
                          <ol>
                            {queue.wrapUpCodes
                              .sort((a, b) => a.name.localeCompare(b.name))
                              .map((code, index) => (
                                <li key={index + 1} className="label-text">
                                  <span className="label-text">{code.name}</span>
                                </li>
                              ))}
                          </ol>
                        </div>
                      )}
                    </div>
                  </div>
                </td>
                <td>
                  <kbd className="kbd">{queue.id}</kbd>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </CatalogTableSurface>
  );
}
